import { Line, mixins } from 'vue-chartjs'

export default {
  extends: Line,
  mixins: [mixins.reactiveProp],
  props: {
    options: {
      type: Object,
      default: {},
    },
    chartData: {
      type: Object,
      default: {},
    },
  },

  data() {
    return {}
  },
  mounted() {
    this.renderChart(this.chartData, this.options)
  },
  //* watch for dynamic updates to chart chartData
  watch: {
    chartData(to, from) {
      this.renderChart(this.chartData, this.options)
    },
  },
}
